/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Navbar from '../../components/Navbar/Navbar';
import {Fade} from 'react-reveal';
import img from '../../assets/back (7).JPG'
import './contact.css'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLocationDot,  } from '@fortawesome/free-solid-svg-icons'
import { FaInstagramSquare, FaFacebook, FaLinkedin } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { useTranslation } from 'react-i18next';




export default function Contact() {
  const { i18n } = useTranslation();

  

  return (
    <>
      <div className="mb-10 w-[100%] flex flex-col tablet:flex-col justify-center items-center m-auto ">
        <header className="sticky top-0 z-50 flex justify-center items-center w-[100%]">
          <div className="m-auto w-[90%] ltr mt-2">
            <Navbar />
          </div>
        </header>

        <div className=' w-[90%]  desktop:w-[80%] tablet:h-[900px] laptop:h-[600px] desktop:h-[500px] desktopXL:h-[600px] flex flex-col laptop:flex-row justify-center laptop:justify-between items-center'>

<div className={`w-[80%] tablet:w-[50%] laptop:w-[30%] m-auto tablet:h-[450px] ltr laptop:mb-9 desktop:mt-24 order-2`}>
              <div className='flex flex-col items-center justify-start '>
                        <Fade right>
                            <span className='w-11/12 m-6 font-english cursor-pointer tablet:w-9/12 laptop:mt-3 laptop:w-8/12'><p className='text-gray-700'><FontAwesomeIcon className='mx-3 text-xl text-stone-700' icon={faLocationDot} />freydonkenar, main street</p></span>
                            <span className='w-11/12 m-6 font-english cursor-pointer tablet:w-9/12 laptop:mt-3 laptop:w-8/12'><p className='text-gray-700'><FontAwesomeIcon className='mx-3 text-xl text-stone-700' icon={faEnvelope} />info@example.com</p></span>
                            <span className='w-11/12 m-6 font-english cursor-pointer tablet:w-9/12 laptop:mt-3 laptop:w-8/12'><p className='text-gray-700'><span className='mx-3 text-lg text-stone-700 fi fi-ir flags grayscale'></span>0098 9111581096</p></span>
                            <span className='w-11/12 m-6 font-english cursor-pointer tablet:w-9/12 laptop:mt-3 laptop:w-8/12'><p className='text-gray-700'><span className='mx-3 text-lg text-stone-700 fi fi-ir flags grayscale'></span>0098 9113847011</p></span>
                            <span className='w-11/12 m-6 font-english cursor-pointer tablet:w-9/12 laptop:mt-3 laptop:w-8/12'><p className='text-gray-700'><span className='mx-3 text-lg text-stone-700 fi fi-ca flags grayscale'></span>001 3689924231</p></span>
                        </Fade> 
              </div>

                  <hr className='border-gray-400 mt-2 mb-2'/>
              <div className='flex justify-center tablet:w-full '>
                        <Fade top>
                            <a href='#' className='tablet:m-3 '><FaInstagramSquare className='m-5 text-xl text-stone-700 hover:text-gray-500 transition-all ease-in-out'/></a>
                            <a href='#' className='tablet:m-3 '><FaSquareXTwitter className='m-5 text-xl text-stone-700 hover:text-gray-500 transition-all ease-in-out'/></a>
                            <a href='#' className='tablet:m-3 '><FaFacebook className='m-5 text-xl text-stone-700 hover:text-gray-500 transition-all ease-in-out'/></a>
                            <a href='#' className='tablet:m-3 '><FaLinkedin className='m-5 text-xl text-stone-700 hover:text-gray-500 transition-all ease-in-out'/></a>
                        </Fade>
              </div>

                    
          </div>
                {/* <span className="border-l-2 desktop:h-[450px] desktopXL:h-[550px] border-gray-400 mx-2"></span> */}

              <div className={`w-full mt-4 h-4/6 tablet:w-[550px] laptop:w-[350px] desktop:w-[650px] desktopXL:w-[850px] 
                              tablet:h-[250px] desktop:h-[400px] desktopXL:h-[550px]
                              order-1 ${i18n.language === 'en' ? 'laptop:order-last' : 'laptop:order-first'}
                                `}>
                    <Fade bottom>
                      <img className='w-full p-1 tablet:h-[100%] desktopXL:h-[550px] tablet:mt-2 laptop:m-auto laptop:h-full desktop:m-auto' src={img} alt="about" />
                    </Fade>
              </div>   
             
        </div>

      </div>
    </>
  )
}
